import React, { CSSProperties, FC } from 'react';
import Color from 'color';

import FontAwesome from '@vromo/ui/components/FontAwesome';
import styled from '@emotion/styled';

const Wrapper = styled.div<{color: string}>`
    margin: 5px;
    padding: 5px 10px;
    border-radius: 1000px;
    font-size: 12px;
    cursor: default;
    background-color: ${({color}) => color};

    i {
        margin-right: 5px;
    }
`;

type Props = {
    icon?: string;
    description: string;
    color: string;
    title?: string;
    style?: CSSProperties;
};

const Pill: FC<Props> = ({ icon, description, color, title, style }) => {
    const backgroundColor = Color(color);
    const textColor = backgroundColor.isDark() ? 'white' : ''
    return (
        <Wrapper
            color={color}
            title={title}
            style={{
                ...style,
                color: backgroundColor.isDark() ? 'white' : '',
            }}>
            {icon ? <FontAwesome icon={icon} weight="regular" color={textColor} /> : null}
            {description}
        </Wrapper>
    );
};

export default Pill;
